// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.04f8907dd',
  revision: '04f8907dd',
  branch: 'develop',
  date: 'Fri, 29 May 2026 09:20:18 GMT'
};